module.exports = __webpack_public_path__ + "static/63gde-6e58291ce9d8c2eaed00bf82a5502f0a.gif";